// import AWSCredential from "@/types/AWSCredential";
import { InjectionKey } from "vue";
import { createStore, Store, useStore as baseUseStore } from "vuex";
import authModule from "@/store/auth/index";

type State = {
  items: any;
  isOpen: any;
  isSubMenuOpen: any;
};

export const key: InjectionKey<Store<State>> = Symbol();

export const store = createStore<State>({
  state() {
    return {
      items: [],
      isOpen: [],
      isSubMenuOpen: [],
    };
  },
  mutations: {
    setItems(state: { items: any[]; }, payload: any) {
      state.items.push(payload);
    },
    setIsOpen(state: { isOpen: any[]; }, payload: any) {
      state.isOpen.push(payload);
    },
    setIsSubMenuOpen(state: { isSubMenuOpen: any[]; }, payload: any) {
      state.isSubMenuOpen.push(payload);
    },
  },
  actions: {
    setItems(context: { commit: (arg0: string, arg1: any) => void; }, payload: any) {
      context.commit("setItems", payload);
    },
    setIsOpen(context: { commit: (arg0: string, arg1: any) => void; }, payload: any) {
      context.commit("setIsOpen", payload);
    },
    setIsSubMenuOpen(context: { commit: (arg0: string, arg1: any) => void; }, payload: any) {
      context.commit("setIsSubMenuOpen", payload);
    },
  },
  modules: {
    authModule,
  },
});

export const useStore = (): Store<State> => {
  return baseUseStore(key);
};
